const GET_ASSIGNMENT_TRANSFER_TYPES = 'GET_ASSIGNMENT_TRANSFER_TYPES';
const SET_ASSIGNMENT_TRANSFER_TYPES = 'SET_ASSIGNMENT_TRANSFER_TYPES';

export {
    GET_ASSIGNMENT_TRANSFER_TYPES,
    SET_ASSIGNMENT_TRANSFER_TYPES
};
